import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import OT from '@opentok/client'

import UpdateBrowserModal from 'src/ui/Modals/UpdateBrowserModal/UpdateBrowserModal'

const UpdateBrowserProvider: React.FC = () => {
  const [showModal, setShowModal] = useState(false)
  const isValidBrowser = (OT.checkSystemRequirements() !== 0)

  useEffect(() => {
    // if browser is invalid and not yet dismissed
    if (!isValidBrowser && !Cookies.get('browser_update_modal_dismissed')) {
      setShowModal(true)
    }
  }, [isValidBrowser])

  return (
    <UpdateBrowserModal
      isOpen={showModal}
      onHide={() => {
        setShowModal(false)
        Cookies.set('browser_update_modal_dismissed', true, {
          // takes a number value for days
          expires: 30,
        })
      }}
    />
  )
}

export default UpdateBrowserProvider
